export default __webpack_public_path__ + "5a7bd330ae115df1b33394afee6b22e0.png";